import type { FormEvent } from 'react';

import { InputDescription, PrimaryButton, SubHeading, TextInput } from '@movingimage-evp/mi-ui-component-library';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { areAllValuesEmptyStrings } from '../../../utils/are-all-values-empty-strings';
import { useFormPersistence } from '../../hooks/use-form-persistence';

import styles from './access-form.module.css';

type Props = {
  isCodeIncorrect: boolean;
  onSubmit: (email: string, firstName?: string, lastName?: string) => void;
};

type FormData = {
  accessCode: string;
};

const initialFormData: FormData = {
  accessCode: '',
};

export function AccessCodeForm({ isCodeIncorrect, onSubmit }: Props) {
  const { webcastId = '' } = useParams();
  const { t } = useTranslation();

  const { formData, handleChange } = useFormPersistence(webcastId, initialFormData, 'accessCodeForm');

  const [formErrors, setFormErrors] = useState<FormData>(initialFormData);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    const errors = {
      accessCode: !formData.accessCode ? t('viewer.views.accessForm.accessCode.errors.required') : '',
    };

    setFormErrors(errors);

    if (areAllValuesEmptyStrings(errors)) {
      onSubmit(formData.accessCode);
    }
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <SubHeading>{t('viewer.views.accessForm.accessCode.title')}</SubHeading>

      <InputDescription
        inputId="access-code-input"
        errorMessage={
          isCodeIncorrect ? t('viewer.views.accessForm.accessCode.errors.incorrectAccessCode') : formErrors.accessCode
        }
        label={t('viewer.views.accessForm.accessCode.inputLabel')}
      >
        <TextInput
          type="password"
          name="accessCode"
          data-testid="access-code-input"
          value={formData.accessCode}
          onChange={handleChange}
        />
      </InputDescription>

      <PrimaryButton type="submit" data-testid="access-event-button">
        {t('viewer.views.accessForm.accessButton')}
      </PrimaryButton>
    </form>
  );
}
